import { ButtonGroup, Icon, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import ListIcon from "@mui/icons-material/List";
import React from "react";
import { useTranslation } from "react-i18next";

const RowOperations = ({
  onClickBookmarks,
  onClickRemove,
  onClickEdit,
  onClickOption,
  optionDisable = false,
  detailTable = false,
  editable = false,
  deletable = false,
  optionTable = false,
}) =>
{
  const { t } = useTranslation();

  //TODO: DELETE TABLE ve OPTION TABLE işlemleri default component'ten çıkarılabilir.
  return (
    <ButtonGroup size="small" aria-label="actions">
      {detailTable ? (
        <Tooltip title={t("detail")} placement="left">
          <IconButton
            color="primary"
            aria-label="detail"
            onClick={onClickBookmarks}
          >
            <LibraryBooksIcon />
          </IconButton>
        </Tooltip>
      ) : null}
      {optionTable ? (
        <Tooltip title={t("option")} placement="left">
          <IconButton
            disabled={optionDisable}
            color="primary"
            aria-label="option"
            onClick={onClickOption}
          >
            <ListIcon />
          </IconButton>
        </Tooltip>
      ) : null}
      {deletable ? (
        <Tooltip title={t("remove")} placement="left">
          <IconButton color="error" aria-label="remove" onClick={onClickRemove}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : null}
      {editable ? (
        <Tooltip title={t("edit")} placement="left">
          <IconButton color="warning" aria-label="edit" onClick={onClickEdit}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      ) : null}
    </ButtonGroup>
  );
};

export default RowOperations;
